<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula Fundamental</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada?.turma?.franquia?.descricao || ''}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>

                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <v-dialog
                        ref="dateDialog"
                        v-model="modal"
                        :return-value.sync="dataAulaDuplicada"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label>Selecione uma data</e-label>
                          <v-text-field
                            dense
                            solo
                            v-model="data_aula"
                            label="Data"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          scrollable
                          :allowed-dates="allowedDates"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dateDialog.save(dataAulaDuplicada)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    class="pt-0 pb-0"
                    v-if="
                      gestaoDeAula.tipo_de_aula !== 'Aula Remota' && !gestaoDeAula.e_aula_infantil
                    "
                    cols="6"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horariosFiltrados"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row v-if="!gestaoDeAula.e_aula_infantil === 1 || !gestaoDeAula.e_aula_infantil">
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Unidades Temáticas</e-label>
                    <div v-if="uniqueUnidadesTematicas.length > 0">
                      <ul>
                        <li
                          v-for="(unidade, index) in uniqueUnidadesTematicas"
                          :key="`ut-${index}`"
                        >
                          {{ unidade }}
                        </li>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Objetos de Conhecimento</e-label>
                    <div v-if="uniqueObjetosConhecimento.length > 0">
                      <ul>
                        <li
                          v-for="(unidade, index) in uniqueObjetosConhecimento"
                          :key="`ut-${index}`"
                        >
                          {{ unidade }}
                        </li>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Habilidades</e-label>
                    <div v-if="allHabilidades.length > 0">
                      <ul>
                        <li v-for="(unidade, index) in allHabilidades" :key="`ut-${index}`">
                          {{ unidade }}
                        </li>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Objetivo de Aprendizagem</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.objetivo_de_aprendizagem }}
                    </p>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Procedimentos Metodológicos</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.procedimentos_metodologicos }}
                    </p>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Material de Apoio</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.material_de_apoio }}
                    </p>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Avaliação da Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.avaliacao_da_aula }}
                    </p>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  style="max-height: 200px; overflow-y: auto"
                  class="elevation-1 rounded mb-4"
                >
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5"> Experiências </e-label>

                    <ul
                      v-for="rotina in gestaoDeAula.rotinas"
                      :key="rotina.id"
                      style="margin-bottom: 16px; font-size: 13px"
                    >
                      {{
                        rotina.descricao
                      }}

                      <ul>
                        <li style="font-size: 12px">
                          {{ rotina.experiencias.join(", ") || "- - -" }}
                        </li>
                      </ul>
                    </ul>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Direitos de Aprendizagem</e-label>
                    <div v-for="rotina in gestaoDeAula.rotinas" :key="rotina.id">
                      <ul style="font-size: 13px; margin-bottom: 12px; margin-top: 12px">
                        {{
                          rotina.descricao
                        }}
                        <ul>
                          <li>{{ rotina.direitos_aprendizagem.join(" | ") || "- - -" }}</li>
                        </ul>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Campos de experiências</e-label>
                    <div v-for="rotina in gestaoDeAula.rotinas" :key="rotina.id">
                      <ul style="font-size: 13px; margin-bottom: 12px; margin-top: 12px">
                        {{
                          rotina.descricao
                        }}
                        <ul>
                          <li
                            v-for="campo in rotina.campos_experiencia_aula"
                            :key="campo"
                            style="font-size: 12px"
                          >
                            {{ campo }}
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium"
                      >Objetivos de Aprendizagem e Desenvolvimento</e-label
                    >
                    <div v-for="rotina in gestaoDeAula.rotinas" :key="rotina.id">
                      <ul style="font-size: 13px; margin-bottom: 12px; margin-top: 12px">
                        {{
                          rotina.descricao
                        }}
                        <ul>
                          <li :key="rotina.id" style="font-size: 12px">
                            {{ rotina.objetivos_aprendizagem || "- - -" }}
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Orientações Metodológicas</e-label>
                    <div v-for="rotina in gestaoDeAula.rotinas" :key="rotina.id">
                      <ul style="font-size: 13px; margin-bottom: 12px; margin-top: 12px">
                        {{
                          rotina.descricao
                        }}
                        <ul>
                          <li :key="rotina.id" style="font-size: 12px">
                            {{ rotina.orientacoes_metodologicas || "- - -" }}
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Recursos</e-label>
                    <div v-for="rotina in gestaoDeAula.rotinas" :key="rotina.id">
                      <ul style="font-size: 13px; margin-bottom: 12px; margin-top: 12px">
                        {{
                          rotina.descricao
                        }}
                        <ul>
                          <li :key="rotina.id" style="font-size: 12px">
                            {{ rotina.recursos || "- - -" }}
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <e-label class="font-weight-medium">Avaliação</e-label>
                    <div>
                      <ul style="font-size: 13px; margin-bottom: 12px; margin-top: 12px">
                        <ul>
                          <li style="font-size: 12px">
                            {{ gestaoDeAula.avaliacao || "- - -" }}
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  :isInfantil="isInfantil"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="!totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      gestoesFiltradas: [],
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },

      horarios: [],
      date: null,
      // horarioSelecionado: null,
      horariosFiltrados: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  created() {
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        this.horarios = val.turma.horarios;
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );

            this.gestoesFiltradas = gestoes.filter(
              (gestao) => gestao.turma_id !== this.gestaoDeAula.turma_id
            );

            this.turmas = this.gestoesFiltradas;
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data_aula = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
    },
  },
  methods: {
    allowedDates(date) {
      if (!this.turmaSelecionada || !this.turmaSelecionada.relacoesDiasHorarios) {
        return false;
      }

      const dayOfWeek = new Date(date).getDay();

      const diasPermitidos = this.turmaSelecionada.relacoesDiasHorarios.map((rel) => rel.dia.id);

      return diasPermitidos.includes(dayOfWeek);
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.turmaSelecionada?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          horariosDoDia = this.turmaSelecionada.relacoesDiasHorarios.map(
            (relacao) => relacao.horario
          );
        } else {
          horariosDoDia = this.turmaSelecionada.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },
    enableSubmit() {
      if (!this.turmaSelecionada.turma.id) {
        this.$toast.danger("Por favor, selecione uma turma");
        return;
      }

      if (!this.dataAulaDuplicada) {
        this.$toast.danger("Por favor, selecione uma data");
        return;
      }

      if (
        this.gestaoDeAula.tipo_de_aula !== "Aula Remota" &&
        !this.horarioSelecionado.id &&
        !this.isInfantil
      ) {
        this.$toast.danger("Por favor, selecione um horário");
        return;
      }

      this.confirmDialog = !this.confirmDialog;
      this.gestaoDeAula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        const payload = {
          ...this.gestaoDeAula,
          horario_inicial: this.horarioSelecionado ? this.horarioSelecionado.inicio : null,
          horario_final: this.horarioSelecionado ? this.horarioSelecionado.final : null,
          horario_id: this.horarioSelecionado ? this.horarioSelecionado.id : null,
          instrutorDisciplinaTurma_id: parseInt(this.turmaSelecionada.id, 10),
          turma_id: this.turmaSelecionada.turma.id,
        };

        const response = await this.$services.aulasService.getAulasInfantisEmConflito(
          this.gestaoDeAula.data,
          this.gestaoDeAula.turma_id
        );
        if (response.data.length > 0) {
          this.$toast.danger("Já existe uma aula cadastrada para essa data");
          this.$loaderService.close();
          return;
        }

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);
        if (Array.isArray(payload.disciplinas)) {
          payload.disciplinas = payload.disciplinas.map((d) => (typeof d === "object" ? d.id : d));
        }

        if (payload.habilidades && typeof payload.habilidades === "object") {
          payload.habilidades = JSON.stringify(payload.habilidades);
        }

        await this.$services.aulasService.criar(payload);

        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
  computed: {
    isInfantil() {
      return this.gestaoDeAula.e_aula_infantil === 1;
    },
    parsedHabilidades() {
      try {
        if (typeof this.gestaoDeAula.habilidades === "string") {
          return JSON.parse(this.gestaoDeAula.habilidades);
        }
        if (Array.isArray(this.gestaoDeAula.habilidades)) {
          return this.gestaoDeAula.habilidades;
        }
      } catch (error) {
        this.$handleError(error);
      }
      return [];
    },

    habilidadesFormatadas() {
      if (Array.isArray(this.parsedHabilidades)) {
        return this.parsedHabilidades
          .map((h) => h.apelido)
          .filter((apelido) => apelido)
          .join(", ");
      }
      return "Sem habilidades cadastradas.";
    },

    uniqueUnidadesTematicas() {
      if (this.parsedHabilidades.length > 0) {
        const unidades = this.parsedHabilidades.map((h) => h.unidades_tematicas).filter(Boolean);
        return [...new Set(unidades)];
      }
      return [];
    },

    uniqueObjetosConhecimento() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.objeto_conhecimento).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },

    allHabilidades() {
      if (this.parsedHabilidades.length > 0) {
        return this.parsedHabilidades.map((h) => h.apelido).filter(Boolean);
      }
      return [];
    },
  },
};
</script>
